// Base URL prepended to local /assets/... references.
// - On normal static hosting this stays "" so paths remain "/assets/...".
// - Inside the WordPress theme, index.php sets window.__ASSET_BASE__ to the
//   theme directory URI so assets resolve from wp-content/themes/<theme>/...
export const ASSET_BASE =
  (typeof window !== "undefined" && window.__ASSET_BASE__) || "";

export const asset = (path) => `${ASSET_BASE}${path}`;
